const fetchImg = (name) => {
    return `https://azweuglostdevobk01.blob.core.windows.net/azdevspacebookingstorage/${name}?st=2023-05-23T12:16:03Z&si=racwdl&spr=https&sv=2022-11-02&sr=c&sig=7MnEGQ1ggmov8odwJtX6ii3h822AYbb%2B3Su67fJOlSA%3D`;
};

export default fetchImg;
